import { createDomain } from 'effector';

const domain = createDomain('audioPlayer');

const player = new Audio();
player.onplay = () => {
  setPlayingAudio(player.src);
};
player.onended = () => {
  setPlayingAudio('');
};
player.onpause = () => {
  setPlayingAudio('');
};
player.onerror = () => {
  setPlayingAudio('');
};

const setPlayingAudio = domain.event<string>();

const $playingAudio = domain
  .store<string>('')
  .on(setPlayingAudio, (_, src) => src);

const playAudio = (
  src: string,
  { loop = true, volume = 1 }: { loop?: boolean; volume?: number } = {}
) => {
  player.loop = loop;
  player.volume = volume;
  if (player.src === src) {
    if (player.paused) {
      player.play();
    } else {
      player.pause();
    }
  } else {
    player.src = src;
    player.play();
  }
};

const unmountAudio = (src: string) => {
  if (player.src === src) {
    player.pause();
    player.src = '';
  }
};

const stopAudio = () => {
  player.pause();
  player.src = '';
};

const setVolume = (volume: number) => {
  player.volume = volume;
};

export const $audioPlayer = {
  $playingAudio,
  playAudio,
  unmountAudio,
  stopAudio,
  setVolume,
};
